import { type_GM_STATE } from '../../helpers'
import { OmneoList, type_WISHLIST_DASHBOARD_STATE } from '../types'
import { ChevronRightIcon } from '../icons/ChevronRightIcon'
import { openModal } from '../helpers/useModal'

declare var GM_STATE: type_GM_STATE
declare var wishlistDashboardState: type_WISHLIST_DASHBOARD_STATE

export function WishlistListHeader({ lists }: { lists: OmneoList[] }) {
  return (
    <div className={`bg-background-light md-max:px-5 md:text-center ${lists.length > 0 ? 'py-[60px] md:py-20' : 'pt-[60px] pb-[30px] md:pt-20 md:pb-[45px]'}`}>
      <h1 className="h2 text-ink uppercase">{wishlistDashboardState.dashboard.title}</h1>
    </div>
  )
}

type contentProps = {
  lists: OmneoList[]
  setPage: React.Dispatch<React.SetStateAction<string>>
  setCurrentList: React.Dispatch<React.SetStateAction<OmneoList>>
}
export function WishlistListContent({ lists, setPage, setCurrentList }: contentProps) {
  const openList = (list: OmneoList) => {
    const urlParams = new URL(window.location.href)
    if (urlParams.hash.includes('#view=detail&id=')) {
      urlParams.hash = `#view=detail&id=${list.id.toString()}`
      window.history.pushState({}, '', urlParams)
    } else {
      urlParams.hash = `#view=detail&id=${list.id.toString()}`
      window.history.pushState({}, '', urlParams)
    }

    setCurrentList(list)
    setPage('detail')

    if (!sessionStorage.getItem('show-share-private')) {
      setTimeout(() => {
        !list.is_shared && openModal('share-private')
      }, 500)
    }
  }

  const openCreateList = async () => {
    openModal('create-list-slideout')
  }

  const { imageDefault } = GM_STATE.wishlist

  return (
    <div className="relative w-full px-5 mx-auto pb-20 min-h-[478px] md:pb-[120px] md:min-h-[516px] md:w-[728px]">
      {lists.map((list: OmneoList) => (
        <div className="w-full py-[15px] border-0 border-t border-solid border-secondary md:py-5" key={list.id}>
          <RenderListItem key={list.id} list={list} imageDefault={imageDefault} openList={openList} />
        </div>
      ))}
      <div className={`w-full ${lists.length > 0 ? 'md:text-right py-[15px] border-0 border-t border-solid border-secondary md:py-5' : 'md:text-center'}`}>
        <button className='Button Button--quaternary-dark' onClick={openCreateList}>{wishlistDashboardState.createNewList}</button>
      </div>
    </div>
  )
}

function RenderListItem({
  list,
  imageDefault,
  openList
}: {
  list: OmneoList
  imageDefault: { src: string; alt?: string }
  openList: (list: OmneoList) => void
}) {
  const imageSrc = list.meta?.image?.src || list.items.find((x) => x?.meta?.image?.src)?.meta.image.src || list.items.find((x) => x?.meta?.image)?.meta.image
  const image = {
    src: imageSrc?.toString() || imageDefault.src,
    alt: list.name || imageDefault.alt
  }

  return (
    <div key={list.id} onClick={() => openList(list)}>
      <div className="flex items-center cursor-pointer w-full">
        <div className="relative h-[93px] w-[74px] bg-light">
          <img className="absolute top-0 left-0 object-cover w-full h-full" src={image.src} alt={image.alt} loading="lazy" />
        </div>
        <div className="flex-1 px-2.5 py-[5px] md:px-5">
          <h4 className="m-0 text-sm text-ink font-light font-sans uppercase">{list.name}</h4>
          <div className="flex items-center mt-2.5 text-subdued text-xs font-light font-calibre">
            <p className="m-0 text-subdued text-xs font-light font-calibre">{list.is_shared ? 'Public' : 'Private'}</p>
            <span className="w-0.5 h-0.5 rounded-full bg-subdued mx-[5px]"></span>
            <span>
              {list.items.length} {list.items.length > 1 ? 'items' : 'item'}
            </span>
          </div>
        </div>
        <ChevronRightIcon className="w-2.5 h-2.5 text-ink" />
      </div>
    </div>
  )
}
